import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);

const state = {
  // 品牌  1:短视频   2:分帐剧
  brand: 1,

  // 全局视频上传
  showVideoUpload: false,
  uploadVideoList: [],

  newMsg: false,

  navMenuCollapse: false,
  reduceObj: false,
  waitDownloadCount: 0,
  scenarioCategory: {},
};
export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  // strict: true
});
